import React, { useEffect } from 'react';
import { ControlButton } from 'Custom-Mindmap';
import { hasCommandKey, isEditingText } from './keyboard';
import useUndoRedo from './useUndoRedo';

// Ctrl/Cmd+Z undoes; Ctrl+Y or Ctrl/Cmd+Shift+Z redoes. Text being edited keeps its own undo.
const keyAction = (event) => {
    if (!hasCommandKey(event) || isEditingText(event.target)) return null;
    const key = event.key.toLowerCase();
    if (key === 'z') return event.shiftKey ? 'redo' : 'undo';
    if (key === 'y') return 'redo';
    return null;
};

const UndoIcon = () => (
    <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
        <path d="M5 3L1.5 6.5L5 10M2 6.5h7.5a4.5 4.5 0 0 1 0 9H6" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
);

const RedoIcon = () => (
    <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" style={{ transform: 'scaleX(-1)' }}>
        <path d="M5 3L1.5 6.5L5 10M2 6.5h7.5a4.5 4.5 0 0 1 0 9H6" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
);

// Undo/redo buttons for the Controls panel, plus the keyboard shortcuts. Hidden for read-only users.
const UndoRedoButtons = ({ disabled }) => {
    const { undo, redo, canUndo, canRedo } = useUndoRedo();

    useEffect(() => {
        if (disabled) return undefined;
        const handleKeyDown = (event) => {
            const action = keyAction(event);
            if (!action) return;
            event.preventDefault();
            if (action === 'undo') undo();
            else redo();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [disabled, undo, redo]);

    if (disabled) return null;
    return (
        <>
            <ControlButton title="undo" name="undo" onClick={undo} disabled={!canUndo}>
                <UndoIcon />
            </ControlButton>
            <ControlButton title="redo" name="redo" onClick={redo} disabled={!canRedo}>
                <RedoIcon />
            </ControlButton>
        </>
    );
};

export default UndoRedoButtons;
